import { lazy } from 'react';

import { ApprovalList, ApprovalDetails } from './approval';

const Analytics = lazy(() => import('./analytics'));
const EditTransaction = lazy(() => import('./analytics/edit-transaction'));

export { Analytics, ApprovalList, ApprovalDetails, EditTransaction };
